module.exports = __webpack_public_path__ + "img/ic_tickets.3cd5b4ee.svg";